import React from 'react';

export const ROOM_TYPE_OPTIONS = [
  { value: 'RB', label: 'RB', title: 'Ready Buyer', className: 'bg-emerald-100 text-emerald-800 border-emerald-300 ring-emerald-500' },
  { value: 'EX', label: 'EX', title: 'Explorer', className: 'bg-amber-100 text-amber-800 border-amber-300 ring-amber-500' },
  { value: 'SK', label: 'SK', title: 'Skeptic', className: 'bg-red-100 text-red-800 border-red-300 ring-red-500' },
];

export function RoomTypeBadge({ value, className = '' }) {
  if (!value) return null;
  const opt = ROOM_TYPE_OPTIONS.find((o) => o.value === value);
  if (!opt) return null;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold border ${opt.className} ${className}`}
      title={opt.title}
    >
      {opt.label}
    </span>
  );
}

/** Toggle chips for RB / EX / SK. Optional — value may be null. */
export default function RoomTypeSelector({ value, onChange, disabled = false, label = 'Lead Type ID' }) {
  return (
    <div>
      <p className="block text-sm font-medium text-gray-700 mb-2">
        {label}{' '}
        <span className="text-gray-400 font-normal">(optional)</span>
      </p>
      <div className="flex flex-wrap gap-2">
        {ROOM_TYPE_OPTIONS.map((opt) => {
          const selected = value === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              disabled={disabled}
              title={opt.title}
              onClick={() => onChange(selected ? null : opt.value)}
              className={`px-4 py-2 rounded-full text-sm font-semibold border transition-all ${
                selected
                  ? `${opt.className} ring-2 ring-offset-1`
                  : 'bg-white text-gray-500 border-gray-200 hover:border-gray-300'
              } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
